import { get, post, remove } from 'src/tools/server';

// onSave
export const setPackage = (body: any, uuid) => {
  return post<any>(`/portal/setting/store/package`, body, {});
};

export const getPackage = (uuid) => {
  return get<any>(`/portal/setting/store/package?packageUuid=${uuid}`, {});
};

export const getPackages = () => {
  return get<any>(`/portal/setting/store/packages`, {});
};

export const delPackage = (uuid) =>
  remove<any>(`/portal/setting/store/package/${uuid}`, {});
